import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api';

const StatistiqueCmdFrs = () => {
    const [etatPercentages, setEtatPercentages] = useState([]);
    const [etatFacturationPercentages, setEtatFacturationPercentages] = useState([]);
    const [stat, setStat] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('commande/get_stat');
                const data = response.data.CommandeFournisseur;
                setStat(data.etat_facturation_percentages)
                console.log(stat)
                setEtatPercentages([
                    { value: parseFloat(data.etat_percentages.total), name: 'total' },
                    { value: parseFloat(data.etat_percentages.partielle), name: 'partielle' },
                    { value: parseFloat(data.etat_percentages['en cours']), name: 'en cours' },
                ]);

                setEtatFacturationPercentages([
                    { value: data.etat_facturation_percentages["facturé"], name: 'facturé' },
                    { value: data.etat_facturation_percentages["non facturé"], name: 'non facturé' },
                    { value: data.etat_facturation_percentages.totalCommandes, name: 'totalCommandes' },
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    const getOptionEtat = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: ['total', 'partielle', 'en cours'],
                textStyle: {
                    color: ['#74788d'],
                },
            },
            color: ['#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf'],
            series: [
                {
                    name: 'Total sales',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: etatPercentages, // Use the data fetched from API
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        };
    };

    const  getOptionFacturation = () => {
        return {
            tooltip: {
                trigger: "axis",
            },
            grid: {
                zlevel: 0,
                x: 50,
                x2: 50,
                y: 30,
                y2: 30,
                borderWidth: 0,
            },
            xAxis: {
                type: "category",
                // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                data: ["totalCommandes", "facturé", "non facturé"],
                axisLable: {
                    color: "#ffffff",
                },
                axisLine: {
                    lineStyle: {
                        color: "#74788d",
                    },
                },
            },
            yAxis: {
                type: "value",
                axisLable: {
                    color: "#ffffff",
                },
                axisLine: {
                    lineStyle: {
                        color: "#74788d",
                    },
                },
            },
            series: [
                {
                    data: stat,
                    type: "line",
                },
            ],
            color: ["#556ee6"],
            textStyle: {
                color: ["#74788d"],
            },
        }
    }
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
                <p>État Paimenent</p>
                <ReactEcharts style={{ height: '350px' }} option={getOptionEtat()} />
            </div>
            <div style={{ flex: 1 }}>
                <p>État Facturation</p>
                <ReactEcharts style={{ height: '350px' }} option={getOptionFacturation()} />
            </div>
        </div>
    );
};

export default StatistiqueCmdFrs;